(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoneyCents(cents) {
    cents = parseInt(cents, 10) || 0;
    var row = $('[data-fitover-price-row]');
    var format = (row && row.getAttribute('data-money-format')) ||
      (window.Shopify && window.Shopify.moneyFormat) ||
      '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace('{{amount}}', dollars + '.' + parts[1])
      .replace('{{amount_no_decimals}}', dollars)
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function initFitoverAccordions() {
    $all('[data-fitover-acc]').forEach(function (wrap) {
      $all('[data-fitover-acc-item]', wrap).forEach(function (item) {
        var btn = $('[data-fitover-acc-toggle]', item);
        if (!btn) return;
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          if (wrap.getAttribute('data-fitover-acc-single') === 'true') {
            $all('[data-fitover-acc-item]', wrap).forEach(function (it) {
              it.classList.remove('is-open');
              var b = $('[data-fitover-acc-toggle]', it);
              if (b) b.setAttribute('aria-expanded', 'false');
            });
          }
          if (!open) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          } else {
            item.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  }

  function initFitoverQty() {
    $all('[data-fitover-qty]').forEach(function (wrap) {
      var input = $('[data-qty-input]', wrap) || $('input[name="quantity"]', wrap.closest('form'));
      var down = $('[data-qty-down]', wrap);
      var up = $('[data-qty-up]', wrap);
      if (!input) return;
      if (down) down.addEventListener('click', function () {
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      });
      if (up) up.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 1) + 1;
      });
    });
  }

  function updateSaveBadgeFromVariant(v) {
    var row = $('[data-fitover-price-row]');
    if (!row || !v) return;
    var saveEl = $('[data-price-save]', row);
    var compEl = $('[data-price-compare]', row);
    if (!saveEl) return;

    if (!v.compare_at_price || v.compare_at_price <= v.price) {
      saveEl.style.display = 'none';
      if (compEl) compEl.style.display = 'none';
      return;
    }

    var mode = row.getAttribute('data-save-mode') || 'amount';
    var prefix = row.getAttribute('data-save-prefix') || 'Save';
    saveEl.style.display = '';

    if (mode === 'percent') {
      var pct = Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
      var prefixEl = saveEl.querySelector('[data-price-save-prefix]');
      var valueEl = saveEl.querySelector('[data-price-save-value]');
      if (prefixEl && valueEl) {
        prefixEl.textContent = prefix;
        valueEl.textContent = pct;
      } else {
        saveEl.textContent = prefix + ' ' + pct;
      }
    } else {
      var cents = v.save_cents || (v.compare_at_price - v.price);
      var amountText = formatMoneyCents(cents);
      var prefixEl = saveEl.querySelector('[data-price-save-prefix]');
      var valueEl = saveEl.querySelector('[data-price-save-value]');
      if (prefixEl && valueEl) {
        prefixEl.textContent = prefix;
        valueEl.textContent = amountText;
      } else {
        saveEl.textContent = prefix + ' ' + amountText;
      }
    }
  }

  function fileKeysMatch(a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    var baseA = a.replace(/\.[^.]+$/, '').split('_')[0];
    var baseB = b.replace(/\.[^.]+$/, '').split('_')[0];
    return baseA.length > 8 && baseA === baseB;
  }

  function selectOptionInput(input) {
    if (!input) return;
    var pos = input.getAttribute('data-option-input');
    var group = input.closest('.fitover-swatches, .fitover-pills, .fitover-option');
    var scope = group || input.closest('.fitover-hero') || document;
    $all('[data-option-input="' + pos + '"]', scope).forEach(function (r) {
      var active = r === input;
      r.checked = active;
      var parent = r.closest('.fitover-swatch, .fitover-pill');
      if (parent) parent.classList.toggle('is-active', active);
    });
  }

  function enforceSingleSelection(scope) {
    var seen = {};
    $all('[data-option-input]:checked', scope || document).forEach(function (input) {
      var pos = input.getAttribute('data-option-input');
      if (!seen[pos]) {
        seen[pos] = input;
        return;
      }
      input.checked = false;
      var parent = input.closest('.fitover-swatch, .fitover-pill');
      if (parent) parent.classList.remove('is-active');
    });
  }

  function syncFormVariantId(form, variantId) {
    if (!form || variantId == null) return;
    var next = String(variantId);
    var hiddenId = form.querySelector('input[name="id"][data-variant-id], input[name="id"]');
    if (hiddenId && hiddenId.value !== next) {
      hiddenId.value = next;
    }
    document.querySelectorAll('kaching-bundles-block').forEach(function (block) {
      if (block.getAttribute('current-variant-id') !== next) {
        block.setAttribute('current-variant-id', next);
      }
    });
  }

  function pauseSlideMedia(slide) {
    if (!slide) return;
    slide.querySelectorAll('video').forEach(function (video) {
      video.pause();
    });
  }

  function playSlideMedia(slide) {
    if (!slide || slide.getAttribute('data-media-type') !== 'video') return;
    slide.querySelectorAll('video').forEach(function (video) {
      video.muted = true;
      video.controls = false;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    });
  }

  function syncActiveSlideMedia(slides, activeIndex) {
    slides.forEach(function (slide, n) {
      if (n === activeIndex) playSlideMedia(slide);
      else pauseSlideMedia(slide);
    });
  }

  function initFitoverGallery() {
    var gallery = $('[data-gallery]');
    if (!gallery) return null;
    if (gallery.__fitoverGalleryApi) return gallery.__fitoverGalleryApi;

    var main = $('[data-gallery-main]', gallery);
    var track = $('[data-gallery-track]', gallery);
    var scrollArea = track || main;
    var slides = $all('[data-gallery-slide]', gallery);
    var thumbs = $all('[data-gallery-thumb]', gallery);
    if (!slides.length) return null;

    var index = 0;
    var mobileQuery = window.matchMedia('(max-width: 980px)');
    var scrollRaf = null;

    var initial = parseInt(gallery.getAttribute('data-gallery-initial'), 10);
    if (!isNaN(initial)) {
      index = initial;
    } else {
      slides.forEach(function (slide, n) {
        if (slide.classList.contains('is-active') || slide.style.display !== 'none') index = n;
      });
    }

    function isMobileGallery() {
      return mobileQuery.matches && slides.length > 1;
    }

    function updateThumbs() {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === index); });
    }

    function setSlideVisibility(activeIndex) {
      slides.forEach(function (slide, n) {
        var active = n === activeIndex;
        slide.classList.toggle('is-active', active);
        if (isMobileGallery()) {
          slide.style.display = 'block';
        } else {
          slide.style.display = active ? '' : 'none';
        }
        if (!active) pauseSlideMedia(slide);
      });
      syncActiveSlideMedia(slides, activeIndex);
    }

    function applyDesktopView() {
      if (!main) return;
      main.classList.remove('is-scroll');
      if (track) track.classList.remove('is-scroll');
      if (track) {
        $all('.fitover-gallery__slide', track).forEach(function (slide) {
          slide.style.flexBasis = '';
          slide.style.width = '';
          slide.style.minWidth = '';
          slide.style.maxWidth = '';
        });
      }
      setSlideVisibility(index);
      updateThumbs();
    }

    function syncSlideWidths() {
      if (!scrollArea || !isMobileGallery() || !track) return;
      var w = scrollArea.clientWidth;
      if (!w) return;
      $all('.fitover-gallery__slide', track).forEach(function (slide) {
        slide.style.flexBasis = w + 'px';
        slide.style.width = w + 'px';
        slide.style.minWidth = w + 'px';
        slide.style.maxWidth = w + 'px';
      });
      scrollArea.scrollLeft = index * w;
    }

    function applyMobileView() {
      if (!main) return;
      main.classList.add('is-scroll');
      if (track) track.classList.add('is-scroll');
      slides.forEach(function (slide) {
        slide.style.display = 'block';
      });
      syncSlideWidths();
      updateThumbs();
    }

    function syncIndexFromScroll() {
      if (!scrollArea || !isMobileGallery()) return;
      var w = scrollArea.clientWidth;
      if (!w) return;
      var next = Math.round(scrollArea.scrollLeft / w);
      next = Math.max(0, Math.min(next, slides.length - 1));
      if (next !== index) {
        pauseSlideMedia(slides[index]);
        index = next;
        updateThumbs();
        playSlideMedia(slides[index]);
      }
    }

    function scrollToIndex(i, behavior) {
      if (!scrollArea || !isMobileGallery()) return;
      pauseSlideMedia(slides[index]);
      index = (i + slides.length) % slides.length;
      var w = scrollArea.clientWidth;
      if (!w) return;
      scrollArea.scrollTo({ left: index * w, behavior: behavior || 'smooth' });
      updateThumbs();
      playSlideMedia(slides[index]);
    }

    function show(i, scrollBehavior) {
      pauseSlideMedia(slides[index]);
      index = (i + slides.length) % slides.length;
      if (isMobileGallery()) {
        scrollToIndex(index, scrollBehavior);
        return true;
      }
      applyDesktopView();
      return true;
    }

    function setGalleryMode() {
      slides.forEach(function (slide) { pauseSlideMedia(slide); });
      if (isMobileGallery()) applyMobileView();
      else applyDesktopView();
      syncActiveSlideMedia(slides, index);
    }

    function showByMediaId(mediaId) {
      if (mediaId == null) return false;
      var id = String(mediaId);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === id) {
          show(i, 'auto');
          return true;
        }
      }
      return false;
    }

    function fileKeyFromSrc(src) {
      if (!src) return '';
      var m = src.match(/\/files\/([^?]+)/);
      return m ? m[1] : '';
    }

    function slideImageSrc(slide) {
      var img = slide && slide.querySelector('img');
      return img ? img.src : '';
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(parseInt(t.getAttribute('data-gallery-thumb'), 10), 'smooth');
      });
    });

    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { show(index - 1, 'smooth'); });
    if (next) next.addEventListener('click', function () { show(index + 1, 'smooth'); });

    if (scrollArea) {
      scrollArea.addEventListener('scroll', function () {
        if (!isMobileGallery()) return;
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(syncIndexFromScroll);
      }, { passive: true });
    }

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', setGalleryMode);
    } else if (mobileQuery.addListener) {
      mobileQuery.addListener(setGalleryMode);
    }

    window.addEventListener('resize', function () {
      if (isMobileGallery()) applyMobileView();
      else applyDesktopView();
    });

    setGalleryMode();
    requestAnimationFrame(function () {
      if (isMobileGallery()) syncSlideWidths();
    });

    var api = { show: show, showByMediaId: showByMediaId, fileKeyFromSrc: fileKeyFromSrc, slideImageSrc: slideImageSrc, slides: slides };
    gallery.__fitoverGalleryApi = api;
    return api;
  }

  function showGalleryForVariant(galleryApi, buybox, variant) {
    if (!galleryApi || !variant) return;
    if (variant.featured_media_id && galleryApi.showByMediaId(variant.featured_media_id)) return;
    if (typeof variant.media_index === 'number' && galleryApi.show(variant.media_index)) return;

    var colorInput = buybox && buybox.querySelector('.fitover-option[data-option-name="Color"] input:checked, .fitover-option[data-option-name="color"] input:checked');
    if (!colorInput) {
      colorInput = buybox && buybox.querySelector('.fitover-swatch input:checked');
    }
    if (!colorInput) return;

    var swatchImg = colorInput.closest('.fitover-swatch');
    swatchImg = swatchImg && swatchImg.querySelector('img');
    var key = galleryApi.fileKeyFromSrc(swatchImg && swatchImg.src);
    if (!key) return;

    for (var i = 0; i < galleryApi.slides.length; i++) {
      var imgKey = galleryApi.fileKeyFromSrc(galleryApi.slideImageSrc(galleryApi.slides[i]));
      if (imgKey === key || fileKeysMatch(imgKey, key)) {
        galleryApi.show(i);
        return;
      }
    }
  }

  function initFitoverVariants() {
    var galleryApi = initFitoverGallery();
    var section = $('.fitover-hero') || document;
    var buybox = $('.fitover-info');
    var form = $('#product-form');
    var dataEl = $('[data-variants-json]');
    if (!buybox || !dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var priceNow = $('[data-price-now]');
    var priceCompare = $('[data-price-compare]');
    var addBtn = $('[data-add-to-cart]');
    var radios = $all('[data-option-input]', section);

    function selectedOptions() {
      var positions = {};
      $all('[data-fitover-color-picker] [data-option-input]:checked, [data-fitover-size-picker] [data-option-input]:checked, #product-form [data-option-input]:checked', buybox).forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-input'), 10) - 1;
        positions[pos] = input.value;
      });
      return Object.keys(positions).sort(function (a, b) { return a - b; }).map(function (key) {
        return positions[key];
      });
    }

    function match(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function updateActive() {
      enforceSingleSelection(buybox);
      radios.forEach(function (r) {
        var parent = r.closest('.fitover-swatch, .fitover-pill');
        if (parent) parent.classList.toggle('is-active', r.checked);
      });
      $all('.fitover-option', buybox).forEach(function (group) {
        var name = (group.getAttribute('data-option-name') || '').toLowerCase();
        if (name !== 'color') return;
        var label = group.querySelector('[data-fitover-color-value]');
        var checked = group.querySelector('input[data-option-input]:checked');
        if (label && checked) label.textContent = checked.value;
      });
    }

    function update() {
      updateActive();
      var v = match(selectedOptions());
      if (!v) return;
      syncFormVariantId(form, v.id);
      var kaching = $('kaching-bundles-block, kaching-bundle');
      if (!kaching) {
        if (priceNow) priceNow.innerHTML = v.price_html;
        if (priceCompare) {
          if (v.compare_at_price > v.price) {
            priceCompare.innerHTML = v.compare_html;
            priceCompare.style.display = '';
          } else {
            priceCompare.style.display = 'none';
          }
        }
        updateSaveBadgeFromVariant(v);
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        var txt = addBtn.querySelector('[data-atc-text]');
        if (txt) txt.textContent = v.available ? (addBtn.getAttribute('data-atc-label') || 'Add to Cart') : 'Sold out';
        if (!kaching) {
          var atcPrice = addBtn.querySelector('[data-atc-price]');
          if (atcPrice) atcPrice.innerHTML = v.price_html;
          var atcCompare = addBtn.querySelector('[data-atc-compare]');
          if (atcCompare) {
            if (v.compare_at_price > v.price) {
              atcCompare.innerHTML = v.compare_html;
              atcCompare.hidden = false;
            } else {
              atcCompare.innerHTML = '';
              atcCompare.hidden = true;
            }
          }
        }
      }
      showGalleryForVariant(galleryApi, buybox, v);
    }

    function onOptionChange(e) {
      if (!e.target.matches('[data-option-input]')) return;
      if (!e.target.closest('.fitover-hero')) return;
      update();
    }

    if (!window.__fitoverVariantChangeBound) {
      window.__fitoverVariantChangeBound = true;
      document.addEventListener('change', onOptionChange);
    }
    update();
  }

  function initFitoverLovedSlider() {
    $all('[data-fitover-loved-slider]').forEach(function (wrap) {
      var track = $('[data-loved-track]', wrap);
      var slides = $all('.fitover-loved__slide', track);
      if (!track || slides.length === 0) return;

      var idx = 0;
      var autoplaySec = parseInt(wrap.getAttribute('data-autoplay') || '3', 10);
      var timer = null;

      function visibleCount() {
        return 3;
      }

      function maxIndex() {
        return Math.max(0, slides.length - visibleCount());
      }

      function stepWidth() {
        var slide = slides[0];
        if (!slide) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 6;
        return slide.getBoundingClientRect().width + gap;
      }

      function render() {
        if (idx > maxIndex()) idx = maxIndex();
        if (idx < 0) idx = 0;
        track.style.transform = 'translateX(-' + (idx * stepWidth()) + 'px)';
      }

      function go(delta) {
        idx += delta;
        if (idx > maxIndex()) idx = 0;
        if (idx < 0) idx = maxIndex();
        render();
      }

      function resetTimer() {
        if (timer) clearInterval(timer);
        if (autoplaySec > 0 && slides.length > visibleCount()) {
          timer = setInterval(function () { go(1); }, autoplaySec * 1000);
        }
      }

      window.addEventListener('resize', render);
      render();
      resetTimer();
    });
  }

  function initFitoverMomentsSlider() {
    $all('[data-fitover-moments-slider]').forEach(function (wrap) {
      var viewport = $('.fitover-moments__viewport', wrap) || wrap;
      var track = $('[data-moments-track]', wrap);
      var cards = $all('.fitover-moments__card', track);
      var dotsWrap = $('[data-moments-dots]', wrap);
      if (!track || cards.length === 0) return;

      var idx = 0;
      var mq = window.matchMedia('(min-width: 900px)');
      var desktopVisible = parseInt(wrap.getAttribute('data-visible-desktop') || '3', 10) || 3;
      var mobileVisible = parseInt(wrap.getAttribute('data-visible-mobile') || '1', 10) || 1;

      var startX = 0;
      var startY = 0;
      var baseX = 0;
      var deltaX = 0;
      var axis = null;
      var dragging = false;

      function isDesktop() {
        return mq.matches;
      }

      function visibleCount() {
        return isDesktop() ? desktopVisible : mobileVisible;
      }

      function pageCount() {
        return Math.max(1, Math.ceil(cards.length / visibleCount()));
      }

      function maxIndex() {
        return Math.max(0, pageCount() - 1);
      }

      function stepWidth() {
        var card = cards[0];
        if (!card) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 20;
        return (card.getBoundingClientRect().width + gap) * visibleCount();
      }

      function setActiveDot() {
        if (!dotsWrap) return;
        $all('.fitover-moments__dot', dotsWrap).forEach(function (dot, n) {
          dot.classList.toggle('is-active', n === idx);
        });
      }

      function applyTransform(offset, animate) {
        track.classList.toggle('is-dragging', !animate);
        track.style.transform = 'translateX(' + offset + 'px)';
      }

      function render() {
        if (idx > maxIndex()) idx = maxIndex();
        if (idx < 0) idx = 0;
        applyTransform(-(idx * stepWidth()), true);
        setActiveDot();
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var pages = pageCount();
        for (var n = 0; n < pages; n++) {
          (function (page) {
            var dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'fitover-moments__dot' + (page === idx ? ' is-active' : '');
            dot.setAttribute('aria-label', 'Go to testimonials page ' + (page + 1));
            dot.addEventListener('click', function () {
              idx = page;
              render();
            });
            dotsWrap.appendChild(dot);
          })(n);
        }
      }

      function onPointerDown(clientX, clientY) {
        if (isDesktop()) return;
        dragging = true;
        axis = null;
        deltaX = 0;
        startX = clientX;
        startY = clientY;
        baseX = -(idx * stepWidth());
        track.classList.add('is-dragging');
      }

      function onPointerMove(clientX, clientY, event) {
        if (!dragging || isDesktop()) return;
        var dx = clientX - startX;
        var dy = clientY - startY;

        if (axis === null) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
          if (axis === 'y') {
            dragging = false;
            track.classList.remove('is-dragging');
            return;
          }
        }

        if (axis !== 'x') return;
        if (event && event.cancelable) event.preventDefault();

        deltaX = dx;
        var maxDrag = stepWidth() * 0.35;
        var next = baseX + dx;
        if (idx === 0 && dx > 0) next = baseX + Math.min(dx, maxDrag) * 0.45;
        if (idx >= maxIndex() && dx < 0) next = baseX + Math.max(dx, -maxDrag) * 0.45;
        applyTransform(next, false);
      }

      function onPointerUp() {
        if (!dragging && axis !== 'x') {
          axis = null;
          return;
        }
        if (isDesktop()) return;

        dragging = false;
        track.classList.remove('is-dragging');

        if (axis === 'x') {
          var threshold = stepWidth() * 0.2;
          if (deltaX <= -threshold && idx < maxIndex()) idx += 1;
          else if (deltaX >= threshold && idx > 0) idx -= 1;
        }

        axis = null;
        deltaX = 0;
        render();
      }

      viewport.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        onPointerDown(e.touches[0].clientX, e.touches[0].clientY);
      }, { passive: true });

      viewport.addEventListener('touchmove', function (e) {
        if (!e.touches || !e.touches[0]) return;
        onPointerMove(e.touches[0].clientX, e.touches[0].clientY, e);
      }, { passive: false });

      viewport.addEventListener('touchend', onPointerUp, { passive: true });
      viewport.addEventListener('touchcancel', onPointerUp, { passive: true });

      mq.addEventListener('change', function () {
        idx = 0;
        dragging = false;
        axis = null;
        buildDots();
        render();
      });
      window.addEventListener('resize', render);
      buildDots();
      render();
    });
  }

  function initFitoverFacebookSlider() {
    $all('[data-fitover-fb-slider]').forEach(function (wrap) {
      var track = $('[data-fb-track]', wrap);
      var cards = $all('.fitover-fb__card', track);
      var prev = $('[data-fb-prev]', wrap);
      var next = $('[data-fb-next]', wrap);
      var dotsWrap = $('[data-fb-dots]', wrap);
      if (!track || cards.length === 0) return;

      var idx = 0;
      var mq = window.matchMedia('(min-width: 900px)');

      function isDesktop() {
        return mq.matches;
      }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        cards.forEach(function (_, n) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'fitover-fb__dot' + (n === idx ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to post ' + (n + 1));
          dot.addEventListener('click', function () {
            idx = n;
            render();
          });
          dotsWrap.appendChild(dot);
        });
      }

      function render() {
        if (isDesktop()) {
          track.style.transform = '';
          return;
        }
        var card = cards[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        var step = card.getBoundingClientRect().width + gap;
        track.style.transform = 'translateX(-' + (idx * step) + 'px)';
        if (dotsWrap) {
          $all('.fitover-fb__dot', dotsWrap).forEach(function (dot, n) {
            dot.classList.toggle('is-active', n === idx);
          });
        }
        if (prev) prev.disabled = cards.length <= 1;
        if (next) next.disabled = cards.length <= 1;
      }

      function go(delta) {
        if (isDesktop()) return;
        idx += delta;
        if (idx >= cards.length) idx = 0;
        if (idx < 0) idx = cards.length - 1;
        render();
      }

      buildDots();
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      mq.addEventListener('change', function () {
        idx = 0;
        buildDots();
        render();
      });
      window.addEventListener('resize', render);
      render();
    });
  }

  function initFitoverReviewLinks() {
    $all('a[href="#fitover-reviews"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.getElementById('fitover-reviews');
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initFitoverPriceGuard() {
    var row = $('[data-fitover-price-row]');
    if (!row) return;
    var compareCents = parseInt(row.getAttribute('data-compare-at-cents'), 10) || 0;
    var compEl = $('[data-price-compare]', row);
    var saveEl = $('[data-price-save]', row);
    if (compareCents > 0 && compEl) {
      compEl.style.display = '';
      if (saveEl) saveEl.style.display = '';
    }
  }

  function initFitoverShopPayRefresh() {
    var checkoutWrap = document.querySelector('.fitover-dynamic-checkout');
    if (!checkoutWrap) return;
    var note = checkoutWrap.querySelector('[data-fitover-shop-pay-note]');

    function syncShopPayNote() {
      if (!note) return;
      var wallet = checkoutWrap.querySelector('shopify-accelerated-checkout, .shopify-payment-button__button');
      var hidden = !wallet
        || wallet.hasAttribute('disabled')
        || wallet.getAttribute('aria-hidden') === 'true'
        || wallet.offsetParent === null
        || window.getComputedStyle(wallet).display === 'none'
        || window.getComputedStyle(wallet).visibility === 'hidden';
      note.hidden = !hidden;
    }

    var refreshTimer = null;
    function refreshPaymentButton() {
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
        try { window.Shopify.PaymentButton.init(); } catch (e) { /* ignore */ }
      }
      syncShopPayNote();
    }

    function scheduleRefreshPaymentButton() {
      if (refreshTimer) window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(refreshPaymentButton, 200);
    }

    refreshPaymentButton();

    var kaching = document.querySelector('kaching-bundles-block, kaching-bundle');
    if (kaching) {
      ['deal-bar-selected', 'variant-selected', 'variants-changed'].forEach(function (name) {
        kaching.addEventListener(name, scheduleRefreshPaymentButton);
      });
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(scheduleRefreshPaymentButton).observe(checkoutWrap, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }

  function initFitoverCartDrawer() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function removeHeaderDrawer() {
      document.querySelectorAll('.shopify-section-header [data-cart-drawer], .shopify-section-header [data-cart-backdrop]').forEach(function (el) {
        el.remove();
      });
    }
    function ensureDrawer() {
      removeHeaderDrawer();
      var drawer = document.querySelector('[data-cart-drawer]');
      if (drawer && drawer.querySelector('.drawer__count-badge')) return;
      fetch(root + '?sections=lumive-cart-drawer&sections_url=' + encodeURIComponent(window.location.pathname), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || !data['lumive-cart-drawer']) return;
          var wrap = document.createElement('div');
          wrap.innerHTML = data['lumive-cart-drawer'];
          var section = wrap.querySelector('.lumive-cart-drawer-root') || wrap.firstElementChild;
          if (!section) return;
          var existing = document.querySelector('.lumive-cart-drawer-root');
          if (existing) existing.replaceWith(section);
          else document.body.appendChild(section);
          removeHeaderDrawer();
        })
        .catch(function () {});
    }
    ensureDrawer();
  }

  function initFitoverHeroRating() {
    $all('.shopify-section--main-product-fitover .fitover-info__rating').forEach(function (row) {
      if (row.dataset.scoreReady === 'true') return;

      var scoreEl = $('.fitover-info__score', row);
      var link = $('.fitover-info__reviews-link', row);
      var stars = $('.stars', row);
      var score = row.getAttribute('data-star-score') || '';

      if (!score) {
        var trustScore = document.querySelector('.fitover-trust__score');
        if (trustScore) score = trustScore.textContent.trim();
      }

      if (score && scoreEl) {
        if (!scoreEl.textContent.trim()) scoreEl.textContent = score;
      } else if (!scoreEl && score) {
        var group = $('.fitover-info__stars-group', row);
        scoreEl = document.createElement('span');
        scoreEl.className = 'fitover-info__score';
        scoreEl.textContent = score;
        if (group) group.appendChild(scoreEl);
        else if (link) row.insertBefore(scoreEl, link);
        else if (stars) stars.insertAdjacentElement('afterend', scoreEl);
        else row.appendChild(scoreEl);
      }

      if (link && !$('.fitover-info__sep', row)) {
        var sep = document.createElement('span');
        sep.className = 'fitover-info__sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = '|';
        row.insertBefore(sep, link);
        link.textContent = link.textContent.replace(/^\s*\(|\)\s*$/g, '').trim();
      }

      row.dataset.scoreReady = 'true';
    });
  }

  function initFitoverSizeGuide() {
    if (window.__fitoverSizeGuideInit) return;
    window.__fitoverSizeGuideInit = true;

    var lastFocus = null;

    function getModal() {
      return $('[data-fitover-size-guide]');
    }

    function openModal() {
      var modal = getModal();
      var dialog = modal && $('.fitover-size-guide__dialog', modal);
      if (!modal || !dialog) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('fitover-size-guide-open');
      dialog.focus();
    }

    function closeModal() {
      var modal = getModal();
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.classList.remove('fitover-size-guide-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-fitover-size-guide-open]')) {
        e.preventDefault();
        openModal();
        return;
      }
      if (e.target.closest('[data-fitover-size-guide-close]')) {
        e.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      var modal = getModal();
      if (!modal || modal.hidden) return;
      if (e.key === 'Escape') closeModal();
    });
  }

  function boot() {
    initFitoverCartDrawer();
    initFitoverAccordions();
    initFitoverQty();
    initFitoverGallery();
    initFitoverVariants();
    initFitoverPriceGuard();
    initFitoverShopPayRefresh();
    initFitoverLovedSlider();
    initFitoverMomentsSlider();
    initFitoverFacebookSlider();
    initFitoverReviewLinks();
    initFitoverHeroRating();
    initFitoverSizeGuide();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    if (!target || !target.querySelector) return;
    if (target.querySelector('.fitover-info__rating')) initFitoverHeroRating();
    if (!target.querySelector('[data-gallery]')) return;
    var gallery = target.querySelector('[data-gallery]');
    if (gallery) gallery.__fitoverGalleryApi = null;
    initFitoverGallery();
    initFitoverVariants();
    initFitoverSizeGuide();
  });
})();
